import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import createCache from "@emotion/cache";
import { Box, createTheme, ThemeProvider } from "@mui/material";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import CustomisedTextField from "../textField/textField";
import ElementTitle from "../title/elementTitle/elementTitle";
import { IFields } from "../../models/additionalFeilds.model";
const theme2 = createTheme({
    direction: "rtl",
});
const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
});
export default function DynamicActionForm(props: any) {


    const [inputs, setInputs] = useState<IFields[]>(props.inputs);

    const updateInput = (index: number, e: any) => {
        let newInputs = Array.isArray(props.inputs) ? [...props.inputs] : [];
        newInputs[index].value = e.target.value.replace(/,/g, "");
        setInputs(newInputs);
        props.updateInput(newInputs);
    };

    const numberHandleKeyDown = (event: any) => {
        var key = event.keyCode ? event.keyCode : event.which;

        if (!/[0-9]/.test(event.key) && key !== 8 && key !== 46) {
            event.preventDefault();
        }
    };

    return (
        <div className="row">
            {props.inputs?.map((item: IFields, index: number) => {
                switch (item.inputType) {
                    case "Note":
                        return (
                            <>
                                <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }}>
                                    <Grid
                                        item
                                        xs={12}
                                        style={{ paddingLeft: "1vh" }}
                                        width={"400px"}
                                    >
                                        {item.description &&
                                            <div className="mb-5 mt-10"><div dangerouslySetInnerHTML={{ __html: item.description || '' }} /></div>
                                        }
                                        <CustomisedTextField
                                            key={index}
                                            label={item.title}
                                            placeholder={item.title}
                                            autoFocus={index == 0}
                                            // required={true}
                                            type="text"
                                            value={item.value}
                                            onChange={(e: any) => updateInput(index, e)}
                                            name={item.key}
                                            id={item.key}
                                            rows={'3'}

                                            error={item.error}
                                        />
                                    </Grid>
                                </Grid>
                            </>
                        );
                    case "TextBox":
                        return (
                            <>
                                <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }}>
                                    <Grid
                                        item
                                        xs={12}
                                        style={{ paddingLeft: "1vh" }}
                                        width={"400px"}
                                    >
                                        {item.description &&
                                            <div className="mb-5 mt-10"><div dangerouslySetInnerHTML={{ __html: item.description || '' }} /></div>
                                        }
                                        <CustomisedTextField
                                            key={index}
                                            label={item.title}
                                            placeholder={item.title}
                                            autoFocus={index == 0}
                                            // required={true}
                                            type="text"
                                            value={item.value}
                                            onChange={(e: any) => updateInput(index, e)}
                                            name={item.key}
                                            id={item.key}
                                            rows={'3'}
                                            error={item.error}
                                        />
                                    </Grid>
                                </Grid>
                            </>
                        );
                    case "Number":
                        return (
                            <>
                                <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }}>
                                    <Grid
                                        item
                                        xs={12}
                                        style={{ paddingLeft: "1vh" }}
                                        width={"400px"}
                                    >
                                        {item.description &&
                                            <div className="mb-5 mt-10"><div dangerouslySetInnerHTML={{ __html: item.description || '' }} /></div>
                                        }
                                        <CustomisedTextField
                                            key={index}
                                            label={item.title}
                                            placeholder={item.title}
                                            autoFocus={index == 0}
                                            // required={true}
                                            type="number"
                                            value={item.value}
                                            onChange={(e: any) => updateInput(index, e)}
                                            name={item.key}
                                            id={item.key}
                                            error={item.error}
                                        />
                                    </Grid>
                                </Grid>
                            </>
                        );
                    case "DropDown":
                        return <></>;

                    default:
                        return (
                            <CustomisedTextField
                                key={index}
                                autoFocus={true}
                                label={item.title}
                                placeholder={item.title}
                                // required={true}
                                type="text"
                                value={item.value}
                                name={item.key}
                                id={item.key}

                            />
                        );
                }
            })}
        </div>
    );
}
